import { IPromise } from 'angular';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import * as _ from 'underscore';

import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { Messages } from '../../codegen/Localize';
import { Module } from '../Module';
import { DeleteOrphanedManagedKeychainRequest } from '../ServerApi/requests/DeleteOrphanedManagedKeychainRequest';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { ToasterService, ToastType } from './ToasterService';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import WebHttpClient from '../../httpClient/WebHttpClient';

export class ClearOrphanedManagedKeychainAction {
  public confirmDeleteOrphanedManagedKeychain(): IPromise<any> {
    const confirmationDialogInstance = openReactConfirmationDialog<void, IResult>({
      title: Messages.clearOrphanedManagedKeychain(),
      message: Messages.clearOrphanedManagedKeychainConfirmMessage(),
      actionName: Messages.clearOrphanedManagedKeychainConfirmButton(),
      paramsForAction: null,
      isActionDelete: true,
      action: () => {
        return WebHttpClient.sendRequest(new DeleteOrphanedManagedKeychainRequest({}));
      },
      dialogWidth: TabDialogWidth.width375px
    });

    confirmationDialogInstance.result.then((result: any) => {
      if (ResultHelper.hasErrors(result)){
        ToasterService.instance.pop({ type: ToastType.Info, text: Messages.clearOrphanedManagedKeychainError() });
      }
      else{
        ToasterService.instance.pop({ type: ToastType.Info, text: Messages.clearOrphanedManagedKeychainSuccess() });
      }
      confirmationDialogInstance.close();
    });

    return confirmationDialogInstance.result;
  }

}

Module.instance().service('ClearOrphanedManagedKeychainAction', ClearOrphanedManagedKeychainAction);